export type { OTPInputGroupProps, BoxInputProps } from './types';
export { default as OTPInputGroup } from './otp-input-group';
export { default as BoxInput } from './sub-components/box-input';
